import React, { useEffect, useState } from "react";
import { constants } from "../../config";
import { NumberInput } from "../Utility/NumberInput";
export const PiecesInput = ({
  //   pieceAmountClass,
  //   pieceTypeClass,
  //   weightClass,
  pieceAmount,
  // handleChangePieceAmount,
  pieceType,
  // handleChangePieceType,
  weight,
  // handleChangeWeight,
  onChangeOrderInfo,
  isWeightClient,
  wasSubmitted,
  successfulSubmissionNotif,
}) => {
  //=========================================//
  const [startedTypingPieceAmount, setStartedTypingPieceAmount] =
    useState(false);
  const [startedTypingWeight, setStartedTypingWeight] = useState(false);

  useEffect(() => {
    setStartedTypingPieceAmount(false);
    setStartedTypingWeight(false);
  }, [successfulSubmissionNotif]);

  const handleChange = (e) => {
    if (e.target.name === "pieceAmount") {
      if (!startedTypingPieceAmount) {
        setStartedTypingPieceAmount(true);
      }
    } else if (e.target.name === "weight") {
      if (!startedTypingWeight) {
        setStartedTypingWeight(true);
      }
      // if (e.target.value.split(".")[1]?.length > 2) {
      //   return; //if they try to add more than two decimal places return.
      // }
    }
    onChangeOrderInfo(e);
  };

  const preventDot = (e) => {
    e.key === "." && e.preventDefault();
  };
  const preventE = (e) => {
    e.key === "e" && e.preventDefault();
  };
  const preventMinus = (e) => {
    e.key === "-" && e.preventDefault();
  };
  const onPieceAmountKeyDown = (e) => {
    preventDot(e);
    preventE(e);
    preventMinus(e);
  };
  const onWeightKeyDown = (e) => {
    preventE(e);
    preventMinus(e);
    preventDot(e);
  };

  const isPieceAmountValid =
    (!startedTypingPieceAmount && !wasSubmitted) ||
    (pieceAmount > 0 && pieceAmount <= constants.CreatingOrder.maxPieceCount);
  const isWeightValid =
    (!startedTypingWeight && !wasSubmitted) ||
    !isWeightClient ||
    (isWeightClient && weight !== "");

  // console.log(startedTypingPieceAmount);
  return (
    <>
      <div className="form-group col-lg-6">
        <label className={isPieceAmountValid ? "" : "text-danger"}>
          Quantity<span className="required-star">*</span>
        </label>
        <div className="form-row">
          <div className="col-4" style={{ minWidth: "55px" }}>
            <NumberInput
              required
              className={
                "form-control " + (isPieceAmountValid ? "" : "border-danger")
              }
              min="1"
              max="99"
              name="pieceAmount"
              value={pieceAmount}
              integerOnly
              positiveOnly
              blockScientificNotation
              onChange={handleChange}
            />
          </div>
          <div className="col">
            <select
              className="form-control"
              name="pieceType"
              value={pieceType}
              onChange={handleChange}
            >
              <option value="">Piece</option>
              <option value="S">Pallet</option>
              <option value="E">Engine</option>
              <option value="M">Transmission</option>
              <option value="O">Oversized</option>
              {/* Andy said we could leave parcel out for now. */}
              {/* <option value="P">Parcel</option> */}
            </select>
          </div>
        </div>

        <small className="form-text text-note pl-1">
          The # of labels needed
        </small>

        {!isPieceAmountValid && (
          <small className="form-text pl-1 text-danger">
            Please enter a valid quantity for the order.
          </small>
        )}
      </div>
      {isWeightClient && (
        <div className="form-group col-lg-6">
          <label className={isWeightValid ? "" : "text-danger"}>
            Weight
            {isWeightClient ? <span className="required-star">*</span> : ""}
          </label>
          <div className="form-row">
            <div className="col-lg-8">
              <div className="input-group">
                <NumberInput
                  className={
                    "form-control " + (isWeightValid ? "" : "border-danger")
                  }
                  required={isWeightClient}
                  min="0"
                  max="10000"
                  name="weight"
                  value={weight}
                  integerOnly
                  positiveOnly
                  blockScientificNotation
                  onChange={handleChange}
                />
                <div className="input-group-append">
                  <div
                    className={
                      "input-group-text " +
                      (isWeightValid ? "" : "border-danger")
                    }
                  >
                    lbs
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!isWeightValid && (
            <small className="form-text pl-1 text-danger">
              Please enter a valid weight for the order.
            </small>
          )}
        </div>
      )}
    </>
  );
};
